<template>
    <div>
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('injectionMolding.title')}}
                <hr>
            </span>
        </h1>
        <div class="row">
            <p>{{$t('injectionMolding.introText')}}</p>
        </div>
        <div class="row in-row">
            <ul class="pic-list">
                <li v-for="(item,index) in InjectionMoldingList[$i18n.locale]" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <h1>{{item.title}}</h1>
                    <p v-html="item.text">{{item.text}}</p>
                    <!-- <router-link to="" class="btn-list">Learn More</router-link> -->
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                InjectionMoldingList:''
            }
        },
        methods:{
            getInjectionMoldingList () {
                this.$api.injectionMolding.injectionMoldingList().then(res=>{
                    this.InjectionMoldingList = res.data.result
                    console.log(res.data.result)
                }).catch(
                    (error) => {
                        console.log(error)
                    }
                )
            }
        },
        mounted() {
            this.getInjectionMoldingList()
        },
    }
</script>

<style scoped>
    .in-row .pic-list li{
        min-height: 38rem;
    }
    @media (max-width: 767px) {
        .in-row .pic-list li{
            min-height: auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Technology/InjectionMolding.vue